import React from 'react';
import { Separator } from '@/components/ui/separator';
import TotalOrdersFilter from './filters/TotalOrdersFilter';
import LastVisitDateFilter from './filters/LastVisitDateFilter';
import AverageOrderValueFilter from './filters/AverageOrderValueFilter';
import TotalSpendFilter from './filters/TotalSpendFilter';
import LoyaltyTierFilter from './filters/LoyaltyTierFilter';

interface FilterSectionProps {
  filters: {
    totalOrders: {
      lowerLimit: number | null;
      upperLimit: number | null;
    };
    lastVisitDate: {
      fromDate: Date | null;
      toDate: Date | null;
    };
    averageOrderValue: {
      lowerLimit: number | null;
      upperLimit: number | null;
    };
    totalSpend: {
      lowerLimit: number | null;
      upperLimit: number | null;
    };
    loyaltyTier: string[];
  };
  onTotalOrdersChange: (lowerLimit: number | null, upperLimit: number | null) => void;
  onLastVisitDateChange: (fromDate: Date | null, toDate: Date | null) => void;
  onAverageOrderValueChange: (lowerLimit: number | null, upperLimit: number | null) => void;
  onTotalSpendChange: (lowerLimit: number | null, upperLimit: number | null) => void;
  onLoyaltyTierChange: (value: string, checked: boolean) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  filters,
  onTotalOrdersChange,
  onLastVisitDateChange,
  onAverageOrderValueChange,
  onTotalSpendChange,
  onLoyaltyTierChange
}) => {
  return (
    <div className="space-y-6 pt-4 border-t">
      <TotalOrdersFilter 
        lowerLimit={filters.totalOrders.lowerLimit}
        upperLimit={filters.totalOrders.upperLimit}
        onChange={onTotalOrdersChange}
      />
      
      <Separator />
      
      <LastVisitDateFilter 
        fromDate={filters.lastVisitDate.fromDate}
        toDate={filters.lastVisitDate.toDate}
        onChange={onLastVisitDateChange}
      />
      
      <Separator />
      
      <AverageOrderValueFilter 
        lowerLimit={filters.averageOrderValue.lowerLimit}
        upperLimit={filters.averageOrderValue.upperLimit}
        onChange={onAverageOrderValueChange}
      />
      
      <Separator />
      
      <TotalSpendFilter 
        lowerLimit={filters.totalSpend.lowerLimit}
        upperLimit={filters.totalSpend.upperLimit}
        onChange={onTotalSpendChange}
      />
      
      <Separator />
      
      <LoyaltyTierFilter 
        selectedValues={filters.loyaltyTier}
        onChange={onLoyaltyTierChange}
      />
    </div>
  );
};

export default FilterSection;